export const APP_CONSTANTS_SESSION = {
  CHECK_INTERVAL: 2 * 60 * 1000, // ⏳ temnpo de check de sessão (De quanto em quanto tempo valida atividade).
  SESSION_DURATION: 30 * 60 * 1000, // ⏳ tempo de sessão total.
  WARNING_TIME: 1 * 60 * 1000, // ⚠️ Tempo de aviso antes de expirar.
  CLOCK_SHOW: 110, // ⚠️ Mostra o relogio de sessão em quantos segundos antes de expirar.
  LOGIN_TIME_KEY: 'loginTimestamp', // 🔑 Chave para armazenar o tempo de login na localStorage.
  ENVIRONMENT: 'PRD', //🌐 Ambiente de produção (PRD) para ativar permanencia mínima, com outro valor qualquer o sistema fica desligado.
};
